import {Component, Inject, Input, OnInit} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {BaseFormComponent, Option, ValidationError} from 'nc-shared';

@Component({
  selector: 'nc-toggle-buttons',
  templateUrl: './nc-toggle-buttons.component.html',
  styleUrls: ['./nc-toggle-buttons.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR, useExisting: NcToggleButtonsComponent, multi: true
  }]
})
export class NcToggleButtonsComponent extends BaseFormComponent {
  @Input() options: Array<Option>;
  @Input() multiple: boolean = false;
  @Input() translate: boolean = true;

  constructor(@Inject('ValidationErrorMap') public errorMap: Record<string, ValidationError>) {
    super(errorMap);
  }

  isControlInvalid(): boolean {
    return super.isControlInvalid() && (this.control.touched || this.control.dirty);
  }
}
